import { Components, Theme } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import scssVariables from '@styles/variables.module.scss';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  defaultProps: {
    shrink: false, // disable the toggleable shrinking of the label, as we use FulltextTooltip instead
  },
  styleOverrides: {
    root: {
      font: scssVariables.FontLabel,
      color: scssVariables.ColorBlack80,
      position: 'static',
      transform: 'none',
      marginBottom: '4px',
      pointerEvents: 'initial',
      maxWidth: '100%', // we overwrite Mui's default as we instead rely on our FulltextTooltip to handle overflow nicely
      variants: [
        {
          props: { visuallyHidden: true },
          style: {
            ...visuallyHidden,
          },
        },
      ],
    },
    asterisk: {
      color: scssVariables.ColorCoral80,
    },
  },
};
